// src/pages/SignupPage.js
import React from "react";
import Signup from "../containers/Auth/Signup";

export default function SignupPage() {
  return <Signup />;
}
